<ng-container *ngIf="(profileType$ | async) === ProfileType.FPLUS">
  <ng-container *ngIf="profileTier$ | async as tier">
    <ng-container *ngIf="notificationData$ | async as notificationData">
      <fcom-notification
        *ngIf="!notificationData.hidden"
        [layout]="NotificationLayout.EDGE_TO_EDGE"
        [isClosable]="true"
        (closeClick)="onCloseNotification()"
        class="notification"
        data-testid="loyalty-global-notification"
      >
        {{ notificationData.message }}
      </fcom-notification>
    </ng-container>
  </ng-container>
</ng-container>
